import { MainLoader, ResourceLoader, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormSection } from 'omni-package-react-core';
import { getProfileApiRoot } from '../../../utils/getProfileApiRoot';
import SecurityQuestionsSection from '../../../components/SecurityQuestionsSection';
import { SecurityQuestions } from '../../../interfaces/SecurityQuestions';
import transformFormRequest from './transformFormRequest';
import Constants from '../../../Constants';
import { SecurityQuestionsResourceInfo } from '../../../components/SecurityQuestionsResource/SecurityQuestionsResource';
import { AccountResourceInfo } from '../../../components/AccountResource';
import { Account } from '../../../interfaces/Account';
import PasswordRow from '../../../components/_PasswordRow';
export interface SecurityQuestionsFormProps { }

const SecurityQuestionsForm: FC<SecurityQuestionsFormProps> = () => {
  const { t } = useTranslation('SecurityQuestionsFormPage');
  const securityQuestions: SecurityQuestions = useScopedSelector(SecurityQuestionsResourceInfo.dataDst);
  const account: Account = useScopedSelector(AccountResourceInfo.dataDst);
  if (!account) return null;
  return (
    <ResourceLoader
      inlineErrorMessage={false}
      buttonAlign="left"
      resourceSrc={SecurityQuestionsResourceInfo.name}
      CustomLoader={MainLoader}
    >
      <Form
        name="securityQuestionsForm"
        url={`${getProfileApiRoot()}/account`}
        createMethod="PATCH"
        transformRequest={(x: unknown) => transformFormRequest(securityQuestions.behaviours.numberOfQuestions, x)}
        confirmationPath={Constants.SecurityQuestionsConfirmationPath}
        infoMessageText={t('informationsLabel')}
        controlErrorMapping={{
          password: 'currentPassword',
        }}
      >
        <FormSection>
          <SecurityQuestionsSection currentSecurityQuestions={account.userSecurityQuestions} />
          <PasswordRow />
        </FormSection>
      </Form>
    </ResourceLoader>
  );
};

export default SecurityQuestionsForm;
